import { FAQ_ITEMS } from "../seo/faqContent.js";
const answer = (q) => FAQ_ITEMS.find((item) => item.q === q).a;
// Startkostnad saknar stöd i den befintliga FAQ:n och påstås därför inte här.
export const TEAM_FAQ_ITEMS = [
  {
    q: "Hur får spelarna sina länkar?",
    a:
      "Efter att registreringen har godkänts bjuder lagledaren in spelarna. " +
      answer("Hur säljer deltagarna?"),
  },
  {
    q: "Måste vi hantera kontanter?",
    a: answer("Behöver säljarna hantera kontanter?"),
  },
  {
    q: "Hur levereras produkterna?",
    a:
      answer("Hur levereras beställningarna?") +
      " " +
      answer("Hur lång tid tar leveransen?"),
  },
  { q: "När betalas pengarna ut?", a: answer("När betalas förtjänsten ut?") },
];
